export default __webpack_public_path__ + "static/media/Detail-documentation.6e9633e6.md";